import { useApiMutation, useApiQuery } from '@/modules/common';

import { TextStyleItem } from '../types';

export function useTextStyleDetails(textStyleId: string) {
  const { isFetching, data, refetch } = useApiQuery<TextStyleItem>(
    `/text-styles/${textStyleId}`,
    {
      queryKey: ['textStyleDetails', textStyleId],
      initialData: null,
    }
  );

  const updateTextStyleMutation = useApiMutation<TextStyleItem>(
    '/text-styles',
    { method: 'PATCH' },
    {
      onSuccess: () => {
        refetch();
      },
    }
  );

  return {
    isFetching,
    details: data,
    updateTextStyleMutation,
  } as const;
}
